import { IUser, IUserProfile } from 'global.interfaces';
import { getTwoCharsInitials } from 'utils/helper';

type UserPersonalDetails = {
  nickname: string;
  avatar: string | null;
  fullName: string;
  lastName: string;
  firstName: string;
  userInitials: string;
};

const getInitialPersonalDetails = (): UserPersonalDetails => ({
  nickname: '',
  avatar: null,
  fullName: '',
  lastName: '',
  firstName: '',
  userInitials: '',
});

export const getPersonalDetails = (user: IUser, userProfile: IUserProfile): UserPersonalDetails => {
  const { profile } = userProfile;
  const initialPersonalDetails = getInitialPersonalDetails();

  if (!profile || !user) {
    return initialPersonalDetails;
  }

  return updatePersonalDetails(user, userProfile, initialPersonalDetails);
};

const updatePersonalDetails = (user: IUser, userProfile: IUserProfile, details: UserPersonalDetails) => {
  const { profile } = userProfile;
  const { fullName, firstName, lastName } = user.profile;
  const userId = user.id;
  const nickname = profile.nickname ?? userId;
  const avatar = profile.avatarUrl;
  const userInitials = getTwoCharsInitials(firstName, lastName);

  return {
    ...details,
    nickname: `@${nickname}`,
    avatar,
    fullName,
    firstName,
    lastName,
    userInitials,
  };
};
